"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgArrowDownIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 21 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M9.265 24.477a1.727 1.727 0 0 0 2.476 0l8.747-8.93a1.815 1.815 0 0 0 0-2.527 1.727 1.727 0 0 0-2.477 0l-5.762 5.887V1.786C12.25.798 11.468 0 10.5 0S8.75.798 8.75 1.786v17.116L2.99 13.025a1.727 1.727 0 0 0-2.477 0 1.815 1.815 0 0 0 0 2.528l8.747 8.93z' }) })));
});
exports.default = (0, react_1.memo)(SvgArrowDownIcon);
